import React from 'react';

import css from './NoSearchResultsMaybe.module.css';
import { OutlineButton } from '../../../components/Button/Button';
import { Link, Text } from '@chakra-ui/react';

const NoSearchResultsMaybe = props => {
  const { listingsAreLoaded, totalItems, location, resetAll, showCreateListingsLink } = props;
  const hasNoResult = listingsAreLoaded && totalItems === 0;
  const hasSearchParams = location.search?.length > 0;

  return hasNoResult ? (
    <div className={css.noSearchResults}>
      We couldn't find any results near you
      <br />
      <Text m={0}>Try adjusting your search area</Text>
      {hasSearchParams ? (
        <OutlineButton onClick={e => resetAll(e)}>Clear filters</OutlineButton>
      ) : null}
      <div className={css.noSearchResultsImageContainer}>
        <img
          className={css.noSearchResultsImage}
          src={
            'https://res.cloudinary.com/dwgqde15s/image/upload/v1747769085/no_results_found_v3_xelpfy.png'
          }
          alt={'Illustration of someone searching for fitness opportunities'}
          referrerPolicy="no-referrer"
        />
      </div>
      <Text className={css.comingSoonMessage} align={'center'} justify={'center'}>
        <strong>We’re not there just yet 👟</strong>
        <br />
        As of January 2026, <span className={css.footfallLogo}>FootFall</span> is launching in
        <strong> Gravesend, Kent</strong>.
        <br />
        <Link href={'https://forms.gle/Vv2AeUz7JZdWyFEMA'} target="_blank" variant="underline">
          Join our waitlist{' '}
        </Link>
        to be the first to know when we expand to your area!
      </Text>
    </div>
  ) : null;
};

export default NoSearchResultsMaybe;
